import React, { useState, useEffect } from 'react';
// import LtheApp from './lthe/App';
import VynApp from './vyn/App';

export const exide_orgs = ['EXIDE_ENERGY', 'CUMMINS', 'DHL', 'GSK', 'FDC']
export const lnt_orgs = ['LTHE', 'BAXTER']
export const dynamicForm_orgs = ['FREEMAN', 'FREEMAN_DEV']
export const isDynamicForm = false
export const selfOnboardingOrg = 'FREEMAN'
 
const App = React.memo(function App() {
  return <VynApp />;
}, (prevProps, nextProps) => {
  // Custom comparison function for React.memo
  const prevOrgId = prevProps.userInfo?.loggedInUser?.orgId;
  const nextOrgId = nextProps.userInfo?.loggedInUser?.orgId;
  return prevOrgId === nextOrgId;
});
 
export default App;
